import React from 'react';

export const DiagnosticsPane = ({ isDiagnosticsMode, diagnosticsRows = [], onPopout }) => {
  if (!isDiagnosticsMode) return null;

  return (
    <aside className="diagnostics-pane" aria-label="Runtime diagnostics">
      <div className="diagnostics-heading">
        <div className="diagnostics-title">Diagnostics</div>
        <button type="button" className="diagnostics-popout-btn" onClick={onPopout}>
          Pop out
        </button>
      </div>
      <dl className="diagnostics-grid">
        {diagnosticsRows.map(([label, value]) => (
          <div className="diagnostics-row" key={label}>
            <dt>{label}</dt>
            <dd>{value || 'n/a'}</dd>
          </div>
        ))}
      </dl>
    </aside>
  );
};
